import { BranchNode } from '../schema/BranchNode';

import type { BranchNode as BranchNodeType } from '../../blueprint/types';
import type { TOSAComponentInput } from '../../types';

export function GetStartedWrapper(props: TOSAComponentInput<BranchNodeType>) {
  return <BranchNode {...props} />;
}
